// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Loader2, Save } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface SaveDiscardPaneProps {
  onDiscard: () => void;
  saving?: boolean;
  saveDisabled?: boolean;
}

export function SaveDiscardPane({ onDiscard, saving, saveDisabled }: SaveDiscardPaneProps) {
  const { t } = useTranslation("back-office");

  return (
    <div className="flex items-center gap-3 rounded-lg border bg-muted/50 p-4">
      <Button type="button" variant="outline" onClick={onDiscard}>
        {t("buttons.discard")}
      </Button>
      <Button type="submit" disabled={saving || saveDisabled}>
        {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
        {t("buttons.save")}
      </Button>
    </div>
  );
}
